module.exports = __webpack_public_path__ + "static/Bill.com-8ceac668092b00ead59ba4f1e19bc660.jpg";